module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "exit-confirmation div-center-horizontally"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-layout', {
    staticClass: "header-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "div-center-vertically div-right-horizontally",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {}
    }
  }, [_c('v-icon', {
    staticClass: "close-icon",
    on: {
      "click": _vm.cancelExit
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "confirm-exit-row",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "confirm-exit-col",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-title-text"
  }, [_vm._v(_vm._s(_vm.$t('ExitConfirmation.title')))]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle-text"
  }, [_vm._v(_vm._s(_vm.$t('ExitConfirmation.subtitle')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "confirmation-btn mt-5 mr-5",
    on: {
      "click": _vm.cancelExit
    }
  }, [_vm._v(_vm._s(_vm.$t('ExitConfirmation.no')))]), _c('v-btn', {
    staticClass: "confirmation-btn mt-5 ml-5",
    on: {
      "click": _vm.confirmExit
    }
  }, [_vm._v(_vm._s(_vm.$t('ExitConfirmation.yes')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d68dda28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/ExitConfirmation.vue
// module id = 1759
// module chunks = 0